<template>
    <div>
        <Header @show-contact="showContact" :active="2" :title="'解决方案'"></Header>
        <!-- 导航栏 -->
        <div class="banner">
            <img class="banner_pc" src="../../assets/image/banner/banner_industry.jpg"></img>
            <img class="banner_m" src="../../assets/image/banner/banner_industry_m.jpg"></img>
        </div>
        <!-- 解决方案 -->
        <div class="plan-t">
            <h1 class="title-t">全景图像拼接和融合展现</h1>
            <div class="bg-t">
                <img class="bg-pc" src="../../assets/image/solution/industry1.jpg"></img>
                <img class="bg-m" src="../../assets/image/solution/industry1_m.jpg"></img>
                <div class="left-t first-b">
                    <h2>亮点</h2>
                    <span>
                        <br>通过6-8个广角摄像头，实时拼接无死角全景画面<br><br>
                        以3D点云形式叠加到全景画面中，解决空间认知偏差问题<br><br>
                        支持用户以第一视角自由环视<br><br>
                        外部全景融合舱内实景<br>
                    </span>
                </div>
            </div>
            <h1 class="title-t">第一视角远程操控、维修指导</h1>
            <div class="bg-t">
                <img class="bg-pc" src="../../assets/image/solution/industry2.jpg"></img>
                <img class="bg-m" src="../../assets/image/solution/industry2_m.jpg"></img>
                <div class="left-t second-b">
                    <h2>亮点</h2>
                    <span>
                        <br>专家可以第一视角远程指导现场技术人员<br><br>
                        远程接入，解决本地技术资源不足问题，提升故障处理效率<br><br>
                        替代实体机器人损耗，在虚拟环境中反复练习<br><br>
                        大幅缩短机器人训练周期<br>
                    </span>
                </div>
            </div>
            <h1 class="title-t">设计研制-数字孪生</h1>
            <div class="bg-t">
                <img class="bg-pc" src="../../assets/image/solution/industry3.jpg"></img>
                <img class="bg-m" src="../../assets/image/solution/industry3_m.jpg"></img>
                <div class="left-t third-b">
                    <h2>亮点</h2>
                    <span>
                        <br>实时构建1:1环境点云，确保CAD模型在真实环境中毫米级对齐<br><br>
                        支持多人同时在MR环境中进行设计标注<br><br>
                        设计修改即时生效，缩短开发周期<br><br>
                        集成CAE工具数据流，在实时渲染应力/热力学云图<br>
                    </span>
                </div>
            </div>
            <h1 class="title-t">生产制造-数据采集与监事控制</h1>
            <div class="bg-t">
                <img class="bg-pc" src="../../assets/image/solution/industry4.jpg"></img>
                <img class="bg-m" src="../../assets/image/solution/industry4_m.jpg"></img>
                <div class="left-t fourth-b">
                    <h2>亮点</h2>
                    <span>
                        <br>设备数据可视化：温度/振动等参数实时显示<br><br>
                        AR作业指导：操作步骤叠加设备，降低错误率<br><br>
                        远程专家支持：实时标注指导，快速故障处理<br>
                    </span>
                </div>
            </div>
        </div>
        <Footer></Footer>
        <Contact v-if="isContactVisible" @close="close"></Contact>
        <Email @show-contact="showContact"></Email>
    </div>
</template>

<script>
import Footer from '../../components/Footer.vue'
import Header from '../../components/Head.vue'
import Contact from '../../components/Contact.vue'
import Email from '../../components/Email.vue'
export default {
    data() {
        return {
            isContactVisible: false
        }
    },
    components: {
        Footer,
        Header,
        Contact,
        Email
    },
    methods: {
        showContact() {
            this.isContactVisible = true
        },
        close() {
            this.isContactVisible = false;
        }
    },
}
</script>

<style scoped>
@import '../../assets/css/solution/industry.css';
@media (max-width: 1200px) {
    .first-b {
        background: #100964 !important;
    }
    .second-b {
        background: #005752 !important;
    }
    .third-b {
        background: #00479d !important;
    }
    .fourth-b {
        background: #00479d !important;
    }

    .title-t{
        font-size: 0.15rem;
        margin: 0.35rem auto 0.12rem;
    }
    
}
</style>